import { relationships } from "@rocicorp/zero";
import { plan } from "./plan";
import { vehicle } from "./vehicle";
import { vehicleAssignment } from "./vehicle-assignment";

export const vehicleAssignmentRelationships = relationships(vehicleAssignment, ({ one }) => ({
	vehicle: one({
		sourceField: ["vehicleId"],
		destField: ["id"],
		destSchema: vehicle,
	}),
	plan: one({
		sourceField: ["planId"],
		destField: ["id"],
		destSchema: plan,
	}),
}));
